module.exports = __webpack_public_path__ + "img/spec_on.1f12e447.png";